import React, { Suspense, useState } from 'react';
import './App.css';
import StockSelector from './components/StockSelector';
import StockUniverse from './components/three/StockUniverse';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] Error caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ color: '#ff0000', padding: '20px', fontFamily: 'monospace' }}>
          <h2>Error rendering StockUniverse:</h2>
          <p>{this.state.error?.toString()}</p>
          <pre style={{ fontSize: '10px', overflow: 'auto' }}>{this.state.error?.stack}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  const [selectedStocks, setSelectedStocks] = useState(null);

  const handleSelectStocks = (stocks) => {
    setSelectedStocks(stocks);
  };

  const handleBackToSelector = () => {
    setSelectedStocks(null);
  };

  return (
    <Suspense fallback={<div className="loading">Loading...</div>}>
      {selectedStocks ? (
        <ErrorBoundary>
          <StockUniverse selectedStocks={selectedStocks} onBack={handleBackToSelector} />
        </ErrorBoundary>
      ) : (
        <StockSelector onSelectStocks={handleSelectStocks} />
      )}
    </Suspense>
  );
}

export default App;
